import React, { useContext } from 'react';
import { Button, Stack, useMediaQuery, useTheme, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import FastForwardIcon from '@mui/icons-material/FastForward';

import { CanvasContext } from "../contexts/CanvasContext";


const QuickActions = (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const { conceptSummary, setConceptSummary,
        setRoleGroupSummary,
        layers, fetchData,
        groups, setGroups,
        overlayMessage, setOverlayMessage,
        loading, setLoading, setSelectedAnimation, setAnimationBlocks, animationBlocks,
        layoutType,
        getComputedTransformValues,
        setElementOffsets,
        setConcept, setLayers,
        suggestionOne, suggestionTwo,
        playAnimation, selectedSegments, API_URL, selectedAnimation, llmType, setLlmType, primaryElementOrientation,
        dragAction, initiateDragDrop, setInitiateDragDrop, generateEdit
    } = useContext(CanvasContext);

    // Updated button styles to match "Edit Animation" button
    const buttonStyles = {
        //     height: isMobile ? "auto" : "100%",
        //     padding: isMobile ? "6px 12px" : "8px 22px",
        //     fontSize: isMobile ? "0.85rem" : "1rem",
        //     minWidth: "90px",

    };

    const handleLlmChange = (event) => {
        const newLlmType = event.target.value;
        setLlmType(newLlmType);

        // Send request to backend to update the LLM type
        fetch(`${API_URL}/set_LLM`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ llm_type: newLlmType }),
        })
            .then(response => response.json())
            .then(data => {
                console.log('LLM updated:', data);
            })
            .catch((error) => {
                console.error('Error updating LLM:', error);
            });
    }

    const handleQuickAction = async (quickActionType) => {

        let elementsInvolvedByRole = {};


        for (const segment of selectedSegments) {
            const { targets, target_type } = segment;

            // If the target_type doesn't exist in the result object, initialize it as an array
            if (!elementsInvolvedByRole[target_type]) {
                elementsInvolvedByRole[target_type] = [];
            }

            // Add the targets to the respective target_type array
            elementsInvolvedByRole[target_type].push(...targets);
        }

        console.log("Elements Involved by Role: " + JSON.stringify(elementsInvolvedByRole));

        setLoading(true);

        let query = `The user has requested an edit to the animation code. They want the elements to be ${quickActionType.toLowerCase()}-ed in the animation. Synchronization can be implemented in different ways: making the elements time in together, making the elements all share the same motion and timing, reducing amount of individual animations so there is less going on, etc.`;

        generateEdit(query);
        // try {
        //     const response = await fetch(`${API_URL}/generate_quick_action_request`, {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //         },
        //         body: JSON.stringify({ query, elementsInvolvedByRole, filename: selectedAnimation, quickActionType }),
        //     });
        //     const data = await response.json();

        //     setOverlayMessage(`Animation First Draft `);
        //     await playAnimation(data.logo_animation);

        //     fetchData();
        //     setLoading(false);

        // } catch (error) {
        // }


    }

    const localGenerateAnimation = async () => {
        setElementOffsets({});
        const userId = localStorage.getItem('userId');

        setLoading(true);

        const layerStates = layers.map(layer => {
            const element = document.getElementById(layer.id);
            const transformValues = getComputedTransformValues(element);

            return {
                id: layer.id,
                left: element.style.left,
                top: element.style.top,
                width: element.style.width,
                height: element.style.height,
                zIndex: element.style.zIndex,
                transform: {
                    translateX: transformValues.translateX,
                    translateY: transformValues.translateY,
                    scaleX: transformValues.scaleX,
                    scaleY: transformValues.scaleY
                },
                src: layer.src,
                alt: layer.alt,
                role: layer.role,
                group: layer.group
            };
        });

        try {
            const response = await fetch(`local_generate_animation`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ layers: layerStates, layout_type: layoutType, userId, llm: llmType, orientation: primaryElementOrientation }),
            });

            const data = await response.json();
            setConcept(data.concept);
            setLayers(data.layers);
            setGroups(data.groups);
            setOverlayMessage(`Animation First Draft `);
            await playAnimation(data.logo_animation, data.filename);
            await fetchData();
            setLoading(false);



        } catch (error) {
            console.error('Error suggesting a design concept :', error);
        }
    };

    return (
        <div style={{
            width: '100%',
            overflowX: 'visible'
        }}>
            <Stack
                direction="row"
                sx={{
                    flexWrap: 'wrap',
                    gap: '0.5em',
                    marginTop: '0.25em',
                }}
            >

                {/* 
                <Button
                    color="secondary"
                    variant="contained"
                    sx={buttonStyles}
                    onClick={localGenerateAnimation}
                    size={isMobile ? "small" : "medium"}
                >
                    Generate (Local Server)
                </Button> */}

                {/* {suggestionOne && (
                    <Button
                        color="secondary"
                        variant="outlined"
                        sx={buttonStyles}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleQuickAction("Subtle");
                        }}
                        size={isMobile ? "small" : "medium"}
                    >
                        {suggestionOne}
                    </Button>)} */}

                {/* {suggestionTwo && (
                    <Button
                        color="secondary"
                        variant="outlined"
                        sx={buttonStyles}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleQuickAction("Subtle");
                        }}
                        size={isMobile ? "small" : "medium"}
                    >
                        {suggestionTwo}
                    </Button>)} */}


                {/* <Button
                    color="secondary"
                    variant="outlined"
                    sx={buttonStyles}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleQuickAction("Synchronize");
                    }}
                    size={isMobile ? "small" : "medium"}
                >
                    Synchronize
                </Button> */}

                {/* <Button
                    color="secondary"
                    variant="outlined"
                    sx={buttonStyles}
                    startIcon={<FastRewindIcon />}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleQuickAction("slow");
                    }}
                    size={isMobile ? "small" : "medium"}
                >
                    Slower
                </Button> */}

                {/* <Button
                    color="secondary"
                    variant="outlined"
                    sx={buttonStyles}
                    startIcon={<FastForwardIcon />}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleQuickAction("fast");
                    }}
                    size={isMobile ? "small" : "medium"}
                >
                    Faster
                </Button> */}

                {/* {dragAction && (
                    <Button 
                        color="secondary"
                        variant="outlined"
                        sx={buttonStyles}
                        onClick={() => setInitiateDragDrop(!initiateDragDrop)}
                        size={isMobile ? "small" : "medium"}
                    > 
                        Redo Timing
                    </Button>
                )} */}

                {/* <FormControl variant="outlined" size="small" style={{ marginLeft: '10px' }}>
                    <InputLabel id="llm-select-label">LLM</InputLabel>
                    <Select
                        labelId="llm-select-label"
                        id="llm-select"
                        value={llmType}
                        onChange={handleLlmChange}
                        label="LLM"
                        style={{ minWidth: '100px' }}
                    >
                        <MenuItem value="claude">Claude</MenuItem>
                        <MenuItem value="gpt">GPT</MenuItem>
                        <MenuItem value="gpt">Gemini</MenuItem>
                    </Select>
                </FormControl> */}
            </Stack>
        </div>
    );
};

export default QuickActions;